import { Normalization } from '~/utils/normalization'

/**
 * Parse a safe redirect path into a navigateTo-compatible target.
 * Handles nested query strings (e.g. /confirm-email?expires=...&id=...)
 * by returning a structured { path, query } object instead of a raw URL string.
 */
export const parseSafeRedirectTarget = (
  url: string
): string | { path: string; query: Record<string, string> } => {
  try {
    const parsed = new URL(url, window.location.origin)
    const query = Object.fromEntries(parsed.searchParams.entries())
    return Normalization.satisfiesMinProperties(query, 1)
      ? { path: parsed.pathname, query }
      : parsed.pathname
  } catch {
    return url
  }
}
